import Left from "./left";
import Right from "./right";

export default { Left, Right };